import {ElMessage} from "element-plus";


export function showToast(data) {
    var message = '';
    var type = 'success';
    var duration = 5 * 1000;
    if (typeof data === 'string') {
        message = data;
    } else {
        if (data.type) {
            type = data.type;
        }
        if (data.duration) {
            duration = data.duration;
        }
    }
    ElMessage({
        message: message,
        type: type,
        duration: duration,
    });
}

export function showSuccessToast(message) {
    innerShowToast('success', message);
}

export function showSuccessToastWithDuration(message, duration) {
    innerShowToastWithDuration('success', message, duration);
}

export function showWarningToast(message) {
    innerShowToast('warning', message);
}
export function showWarningToastWithDuration(message, duration) {
    innerShowToastWithDuration('warning', message, duration);
}

export function showErrorToast(message) {
    innerShowToast('error', message);
}

export function showInfoToast(message) {
    innerShowToast('info', message);
}

export function innerShowToast(type, message) {
    ElMessage({
        message: message,
        type: type,
        duration: 5 * 1000,
    });
}

export function innerShowToastWithDuration(type, message, duration) {
    ElMessage({
        message: message,
        type: type,
        duration: duration,
    });
}

export function navigateTo(url) {
    this.$router.push(url);
}

export function verifyEmail(email) {
    if (email === "") {
        return false;
    } else {
        if (email !== "") {
            var reg =
                /^[A-Za-z0-9\u4e00-\u9fa5-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (reg.test(email)) {
                return true;
            } else {
                return false;
            }
        }
    }
}

export function closeAllToast() {
    ElMessage.closeAll();
}
